var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { forwardRef } from "react";
import { useId } from "./util/useId";
const SvgCloudSlashFill = forwardRef((_a, ref) => {
    var { title, titleId: _titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    let titleId = useId();
    titleId = title ? (_titleId ? _titleId : "title-" + titleId) : undefined;
    return (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: false, role: "img", ref: ref, "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.335 6.226a.75.75 0 1 0-1.06-1.06L3.97 19.47a.75.75 0 1 0 1.06 1.06L19.335 6.226Zm-5.085.842a.24.24 0 0 0-.03-.37c-.897-.61-1.96-.948-3.165-.948-3.161 0-5.653 2.573-5.886 5.87v.001l-.001.019a.178.178 0 0 1-.135.16H5.03l-.01.003c-.814.216-1.51.602-2.008 1.17-.503.576-.762 1.295-.762 2.093 0 .925.342 1.75 1.012 2.332.068.06.139.116.212.169a.237.237 0 0 0 .307-.03L14.25 7.068ZM9.859 17.823a.25.25 0 0 0 .177.427h7.263c2.483 0 4.451-1.92 4.451-4.379 0-1.187-.465-2.297-1.352-3.104-.586-.533-1.334-.915-2.212-1.112a.244.244 0 0 0-.226.067L9.86 17.823Z", fill: "currentColor" })));
});
export default SvgCloudSlashFill;
